import { render, staticRenderFns } from "./message-record-send.vue?vue&type=template&id=f3e72f60&"
import script from "./message-record-send.vue?vue&type=script&lang=js&"
export * from "./message-record-send.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports